import { render, staticRenderFns } from "./scene.vue?vue&type=template&id=28736558&scoped=true&"
import script from "./scene.vue?vue&type=script&lang=ts&"
export * from "./scene.vue?vue&type=script&lang=ts&"
import style0 from "./scene.vue?vue&type=style&index=0&id=28736558&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28736558",
  null
  
)

export default component.exports